export const vMetricsConstants = {


    GETALL_REQUEST: 'vMetrics_GETALL_REQUEST',
    GETALL_SUCCESS: 'vMetrics_GETALL_SUCCESS',
    GETALL_FAILURE: 'vMetrics_GETALL_FAILURE'
};
